
import {isNumber} from "../lib/underscore.js";
import {isNumberArray} from "./validate.js";
import {createModel} from "./model.js";

// CONSIDER: these default values are closely tied with the hash fragment serializer's behavior (like the absence of
// "anim=off" means animation is enabled, and vice versa with grid=on. This is annoyingly coupled... Would also
// be affected if hd_enabled or other fields are added into the shared store.

// maybe stuff in here should be those attributes which can affect product loading. and everything else, like
// spotlight_coords, goes in a different store. the hash fragment maintainer is then tasked with watching and merging
// together the fields that are encoded in the hash

const schema = {
    // name of a mode
    mode:              ["string", "air"],
    // name of a supported projection
    projection_type:   ["string", "orthographic"],
    // {scale: number, rotate: number[2], translate: number[2]}
    orientation:       [isOrientation, undefined],

    // "now" or ISO date string (always UTC)
    time_cursor:       ["string", "now"],
    // name of a level
    z_level:           ["string", "surface"],
    // name of a supported animation type
    animation_type:    ["string", "wind"],  // animation_name?
    // name of an overlay
    overlay_type:      ["string", "wind"],  // overlay_name?
    // name of an annotation layer to show
    annotation_type:   ["string", "none"],  // annotation_name?

    // [λ, φ] coordinates of spotlight marker or undefined if no spotlight enabled
    spotlight_coords:  [isTwoNumbers, undefined],
    // true if indicators for the location of layer grid points is to be shown
    show_grid_points:  ["boolean", false],
    // true if the animation layer should actually run the animation
    animation_enabled: ["boolean", true],
};

function isTwoNumbers(val) {
    return isNumberArray(val) && val.length === 2;
}

function isOrientation(val) {
    return (val.scale === undefined || isNumber(val.scale)) &&
        (val.rotate === undefined || isTwoNumbers(val.rotate)) &&
        (val.translate === undefined || isTwoNumbers(val.translate));
}

export const sharedStore = createModel(schema);
